import {Component, OnInit} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {SearchHelpers} from "../../helpers/search-helper";

export interface SelectK2SiteNameModel {
  k2Sites: any[];
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./select-k2-site-name-dialog.template.pug",
  providers: [
  ],
})
export class SelectK2SiteNameComponent extends DialogComponent<SelectK2SiteNameModel, any>
  implements SelectK2SiteNameModel, OnInit {
  error: Error;
  k2Sites: any[] = [];
  k2SitesFiltered: any[] = [];
  k2SitesToShow: any[] = [];

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number = 1;
  searchText: string = "";

  static showSelectK2SiteNameDialog(dialogService: DialogService, input: SelectK2SiteNameModel): Promise<any> {
    return dialogService.showDialog(SelectK2SiteNameComponent, input);
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  cancel(): void {
    this.result = {};
    this.close();
  }

  selectSite(id) {
    this.result = this.k2Sites.find(site => site.id === id);
    this.close();
  }

  ngOnInit(): void {
    this.loadSites();
  }

  private loadSites(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.k2SitesFiltered = this.k2Sites.filter((k2Site) => {
      if (this.searchText) {
        const values = [
          k2Site.name,
        ].filter(it => !!it);

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }

      return true;
    });

    // Cut down the list of sites to only those we'll show
    this.k2SitesToShow = this.k2SitesFiltered.slice(start, end);
    this.maxPages = Math.ceil(this.k2SitesFiltered.length / (+this.pageSize));
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        break;
    }

    this.loadSites();
  }
}
